import { any } from 'prop-types'
import React, { useReducer, createContext } from 'react'
const defaultGlobalState = {
  bookmarks: [],
}
const globalStateContext = createContext(defaultGlobalState)
const dispatchStateContext = createContext(undefined)

const useGlobalState = () => [
  React.useContext(globalStateContext),
  React.useContext(dispatchStateContext),
]

const GlobalStateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    (state, newValue) => ({ ...state, ...newValue }),
    defaultGlobalState
  )
  return (
    <globalStateContext.Provider value={state}>
      <dispatchStateContext.Provider value={dispatch}>
        {children}
      </dispatchStateContext.Provider>
    </globalStateContext.Provider>
  )
}

GlobalStateProvider.propTypes = {
  children: any,
}

export { GlobalStateProvider }
export default useGlobalState
